import React, { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import SignupPromptModal from './SignupPromptModal';
import DailyLimitUpgradeModal from './DailyLimitUpgradeModal';

/**
 * LimitModalProvider — Kayıt Duvarı (registration wall) koordinatörü.
 * Hicbir alt component'e prop gondermek gerekmiyor; window event'leri
 * uzerinden calisir. App.js icinde bir kez mount edilir.
 *
 * Dinledigi event'ler:
 *   - 'auth:required'       → Misafir kullanici AI sorgusu baslatti; istek
 *                             AI'ye gonderilmeden kesildi (403 AUTH_REQUIRED —
 *                             backend requireAuthForAI). Arka plan blur'lanir +
 *                             SignupPromptModal acilir. Kayit sonrasi bekleyen
 *                             sorgu otomatik yeniden gonderilir.
 *   - 'limit:daily-exceeded'→ Login kullanici 3/gun limitini asti (HTTP 429).
 *                             DailyLimitUpgradeModal acilir (upgradeOptions ile).
 */
const GUEST_BLUR_CLASS = 'guest-result-blur';

const LimitModalProvider = () => {
  const location = useLocation();
  const [signupOpen, setSignupOpen] = useState(false);
  const [dailyOpen, setDailyOpen] = useState(false);
  const [upgradeOptions, setUpgradeOptions] = useState(null);

  const closeSignup = useCallback(() => {
    setSignupOpen(false);
    // Blur, kayit olmadi surece kalir: kapatmak misafire sonuc erisimi vermez.
    // Yalnizca sayfa degisiminde kaldirilir (alttaki location effect).
  }, []);

  const closeDaily = useCallback(() => {
    setDailyOpen(false);
    setUpgradeOptions(null);
  }, []);

  useEffect(() => {
    const onAuthRequired = () => {
      // Kayit duvari: arka plani blur'la + kayit/giris modalini ac.
      try {
        document.body.classList.add(GUEST_BLUR_CLASS);
      } catch (_) {}
      setSignupOpen(true);
    };

    const onDailyExceeded = (e) => {
      const detail = e?.detail || {};
      setUpgradeOptions(detail.upgradeOptions || null);
      setDailyOpen(true);
    };

    window.addEventListener('auth:required', onAuthRequired);
    window.addEventListener('limit:daily-exceeded', onDailyExceeded);
    return () => {
      window.removeEventListener('auth:required', onAuthRequired);
      window.removeEventListener('limit:daily-exceeded', onDailyExceeded);
    };
  }, []);

  // Kullanici sayfadan ayrilirsa blur'u temizle.
  useEffect(() => {
    document.body.classList.remove(GUEST_BLUR_CLASS);
    setSignupOpen(false);
  }, [location.pathname]);

  return (
    <>
      <SignupPromptModal
        isOpen={signupOpen}
        onClose={closeSignup}
      />
      <DailyLimitUpgradeModal
        isOpen={dailyOpen}
        upgradeOptions={upgradeOptions}
        onClose={closeDaily}
      />
    </>
  );
};

export default LimitModalProvider;
